import {InjectionToken} from '@angular/core';
// Version 2.0.2 has no package-level entry point; use its typed ES module directly.
import * as webEid from '@web-eid/web-eid-library/web-eid';

export type WebEidClient = Pick<typeof webEid, 'getSigningCertificate' | 'sign'>;

// Keep the browser bridge injectable so signing can be tested without a card or extension.
export const WEB_EID = new InjectionToken<WebEidClient>('Web eID', {
  providedIn: 'root',
  factory: () => webEid
});
